import React from "react";
import PatientListMisuseTable_rowItems from "./patientListMisuseTable_rowItems";
import TableLoader from "../../../../../general/table/tableLoader";
import EmptyRow from "../../../../../general/table/emptyRow";

type PatientAppointmentsTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const patientListMisuseTable = ({
  dataList,
  dataListTitles,
  isRequesting
}: PatientAppointmentsTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i} className='text-black font-weight-semibold font-12 '>{item}</td>),
    _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
      return <PatientListMisuseTable_rowItems item={item} key={i}/>
    });
  return (
    <table className='border-rounded font-en' >
      <thead>
      <tr>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody className="bg-gray">
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default patientListMisuseTable;
